export default "__VITE_PUBLIC_ASSET__c0cf87af__"